import api from '@services/api';
import { DetailsRequest, UndoUnionDetailsRequest, UnitDetailsRequest } from '../models/details';
import { DetailsTravelItemUpdate, DetailsTravelResponse, DetailTravelTransfer } from '../models/detailsTravel';

/**
 * <p>
 * API endpoints that cover all travel related CRUD calls
 */
export const detailsTravelApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchDetailsTravel: builder.query<DetailsTravelResponse, DetailsRequest>({
      query: (params: DetailsRequest) => ({
        url: encodeURI(
          `/report/details-travel/search?searchTerm=${params.searchTerm}&projectCode=${params.project}&period=${params.period}&subgroup=${params.subGroup}`,
        ),
      }),
      providesTags: ['SearchDetailsTravel', 'SearchEquipment', 'SearchDetails'],
    }),
    UnitTravel: builder.mutation<void, UnitDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-travel/group`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsTravel'],
    }),
    undoUnionTravel: builder.mutation<void, UndoUnionDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-travel/ungroup`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsTravel'],
    }),
    updateDetailsTravel: builder.mutation<void, DetailsTravelItemUpdate>({
      query: (project) => ({
        url: encodeURI(`/report/details-travel/update`),
        method: 'PUT',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsTravel'],
    }),
    TravelTransfer: builder.mutation<void, DetailTravelTransfer>({
      query: (project) => ({
        url: encodeURI(`/report/details-travel/transfer`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsTravel', 'SearchDetails'],
    }),
  }),
});

export const {
  useSearchDetailsTravelQuery,
  useUnitTravelMutation,
  useUndoUnionTravelMutation,
  useUpdateDetailsTravelMutation,
  useTravelTransferMutation,
} = detailsTravelApi;
